import React, { useRef, useState, useEffect } from "react";
import { DEFAULT_PER_PAGE } from "../../../helpers/default";
import ContentBlock from "../../../components/Layout/ContentBlock";
import FilterMenu from "../../../components/Layout/FilterMenu";
import { QueryClient, useMutation, useQuery } from "react-query";
import Axios from "axios";
import ContentValidation from "../../../components/common/ContentValidation";
import {
  ButtonSecondary,
  Label,
  Pagination,
  RangePicker,
  SelectInput,
  TextInput,
} from "../../../components/globals";
import TableFilterBox from "../../../components/common/TableFilterBox";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../../helpers/FunctionsGlobal";
import useFetch from "../../../hooks/useFetch";
import {
  antdMessageError,
  antdMessageSuccess,
  exportDocument,
  getDateFormat,
  customAntdMessage,
} from "../../../helpers/Utils";
import { ButtonDelete, ButtonSmall } from "../../../components/common/Buttons";
import { IconDot, IconSearch } from "../../../components/Layout/Icons";
import AntdConfirm from "../../../helpers/AntdConfirm";
import ModalSimple from "../../../components/Layout/Modals/ModalSimple";
import { FiUpload } from "react-icons/fi";
import { queryProductsClient } from "..";
import { generateParams, labelTranslates } from "../../../utils/filtering";
import ProductMassImportById from "./ProductMassImportById";
import {
  antdAsyncMessageError,
  antdAsyncMessageLoading,
  antdAsyncMessageSuccess,
} from "../../../helpers/AsyncMessage";
import { colors } from "../../../utils/colors";
import { formatDateTime } from "../../../utils/date";
import TabUi from "./TabUi";

export const queryLostCartsClient = new QueryClient();
const fetcher = async ({ queryKey }) => {
  const [key, { page, perPage, filterStr }] = queryKey;
  const response = await Axios.get(
    `/api/v1/${key}?page=${page}&per_page=${perPage}${filterStr}`
  );
  return response.data;
};

const initialMassImportFilters = {
  asset_cont_any: "",
  status_i_cont_any: "",
  created_at: ["", ""],
  user_firstname_or_user_lastname_cont: "",
};

const ProductMassImport = ({ tabId, setTabId }) => {
  const { value: suppliers } = useFetch(
    "/api/v1/suppliers",
    {},
    [],
    (value) => {
      return value.data.map(({ id, name }) => ({
        value: id,
        label: name,
      }));
    }
  );

  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(DEFAULT_PER_PAGE);
  const [filters, setFilters] = useState(initialMassImportFilters);
  const [filterStr, setFilterStr] = useState("");
  const [previewById, setPreviewById] = useState(null);
  const [createRecordModal, setCreateRecordModal] = useState(false);

  const {
    isLoading,
    error,
    data: { totals = 0, data = [] } = {},
    refetch,
  } = useQuery({
    queryKey: ["product_imports", { page, perPage, filterStr }],
    queryFn: fetcher,
  });

  const mutationRemove = useMutation({
    mutationFn: ({ id }) => {
      antdAsyncMessageLoading({
        key: `remove_product_import`,
        message: "Deleting product import",
      });
      return Axios.delete(`/api/v1/product_imports/${id}`);
    },
    onSuccess: (data) => {
      console.log({ data });
      antdAsyncMessageSuccess({
        key: "remove_product_import",
        message: "Successfully removed",
      });
      queryProductsClient.setQueryData([
        "product_imports",
        { page, perPage, filterStr },
      ]);
    },
    onError: (error) => {
      antdAsyncMessageError({
        key: "remove_product_import",
        message: error.response.data.message,
      });
    },
  });

  console.log({ mutationRemove });

  return (
    <>
      <ContentBlock>
        <FilterMenu
          totals={totals}
          length={data.length}
          text2="Products"
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
        />
      </ContentBlock>
      <div className="col-12">
        <TabUi tabId={tabId} setTabId={setTabId} />
      </div>
      {!!previewById ? (
        <ProductMassImportById
          product_import={previewById}
          onClose={() => {
            setPreviewById(null);
          }}
        />
      ) : (
        <ContentBlock containerClass={"py-1"}>
          <TableFilterBox
            filter={true}
            onFilter={() => {
              if (generateParams(filters) == filterStr && page == 1) {
                return refetch();
              }
              setFilterStr(generateParams(filters));
              setPage(1);
            }}
            add={false}
            clearFilter={() => setFilters(initialMassImportFilters)}
            button1={
              <div
                className="float-left ml-2"
                style={{
                  width: 104,
                }}
              >
                <ButtonSecondary onClick={() => setCreateRecordModal(true)}>
                  Import file
                </ButtonSecondary>
              </div>
            }
          >
            <div className="d-flex justify-content-between flex-1 flex-wrap">
              <div className="d-flex flex-wrap">
                {Object.entries(filters).map(([key, value]) =>
                  key == "product_suppliers_supplier_id_in" ? (
                    <div className="px-1" key={key}>
                      <SelectInput
                        mode="multiple"
                        label={labelTranslates[key]}
                        name={key}
                        value={value}
                        style={{ width: "165px" }}
                        options={suppliers}
                        onChange={(val) => {
                          setFilters((prev) => ({ ...prev, [key]: val }));
                        }}
                      />
                    </div>
                  ) : key == "created_at" ? (
                    <div className="px-1" key={key}>
                      <RangePicker
                        label={labelTranslates[key]}
                        style={{ width: 250 }}
                        value={
                          !!value
                            ? [getDateFormat(value[0]), getDateFormat(value[1])]
                            : []
                        }
                        onChange={(_, args) => {
                          setFilters((prev) => ({
                            ...prev,
                            [key]: args,
                          }));
                        }}
                      />
                    </div>
                  ) : (
                    <div className="px-1" key={key}>
                      <TextInput
                        text={labelTranslates[key]}
                        name={key}
                        value={value}
                        style={{ width: "165px" }}
                        onKeyDown={handleKeyDown2(() => {
                          if (
                            generateParams(filters) == filterStr &&
                            page == 1
                          ) {
                            return refetch();
                          }
                          setFilterStr(generateParams(filters));
                          setPage(1);
                        })}
                        onChange={onChangeUseState(setFilters)}
                      />
                    </div>
                  )
                )}
              </div>
            </div>
          </TableFilterBox>
          <ContentValidation loader={isLoading} array={data} error={error}>
            <div className="table-responsive" style={{ overflow: "hidden" }}>
              <table className="table mt-3">
                <thead>
                  <tr className="text-muted">
                    <th className="text-black">File</th>
                    <th className="text-black">Products quantity</th>
                    <th className="text-black">Status</th>
                    <th className="text-black">Upload date</th>
                    <th className="text-black">Uploader</th>
                    <th className="text-black"></th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => {
                    const status =
                      item.total_imported == 0
                        ? "danger"
                        : item.total_imported == item.products
                        ? "success"
                        : "warning";
                    return (
                      <tr className="align-middle tableColumn" key={item.id}>
                        <td className="align-middle">{item.asset.name}</td>
                        <td className="align-middle">{item.products}</td>
                        <td className="align-middle">
                          <IconDot color={colors[status]} />
                          {status == "success"
                            ? "All imported"
                            : status == "danger"
                            ? "Not imported"
                            : `${item.total_imported} of ${item.products} imported`}
                        </td>
                        <td className="align-middle">
                          {formatDateTime(item.created_at)}
                        </td>
                        <td className="align-middle">{item.uploader}</td>
                        <td className="align-middle">
                          <div
                            className="d-flex justify-content-end"
                            style={{
                              gap: 5,
                            }}
                          >
                            <ButtonSmall
                              onClick={() => {
                                setPreviewById(item);
                              }}
                            >
                              <IconSearch color="#fff" />
                            </ButtonSmall>
                            <ButtonDelete
                              disabled={mutationRemove.isLoading}
                              onDelete={() => {
                                AntdConfirm({
                                  onOk: () => {
                                    mutationRemove.mutate({ id: item.id });
                                  },
                                });
                              }}
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <Pagination
                setPagination={setPage}
                page={page}
                totals={totals}
                pageCount={perPage}
              />
            </div>
          </ContentValidation>
        </ContentBlock>
      )}
      {createRecordModal && (
        <ModalPreview
          refetch={refetch}
          onClose={() => {
            setCreateRecordModal(false);
          }}
        />
      )}
    </>
  );
};

export default ProductMassImport;

// Others

const ModalPreview = ({ refetch, onClose }) => {
  const fileRef = useRef();
  const [documents, setDocuments] = useState([]);

  console.log({ documents });

  const mutationFile = useMutation({
    mutationFn: (body) => {
      return Axios.post("/api/v1/product_imports", body, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    },
    onSuccess: async () => {
      refetch();
      onClose();
      antdMessageSuccess();
    },
    onError: (error) => showCustomErrorMessage(error?.response?.data?.message),
  });

  const showCustomErrorMessage = (errorMessage) => {
    customAntdMessage(
      "Errors in Uploaded File",
      errorMessage || "Error occurred",
      "error"
    );
  };

  return (
    <ModalSimple text="Import products" hide={true} onClose={onClose}>
      <p style={{ color: "#1D1D1D", marginTop: 0, marginBottom: 10 }}>
        Creating products through import.
      </p>
      <input
        hidden={true}
        ref={fileRef}
        type="file"
        onChange={async (e) => {
          const file = e.target.files[0];

          if (
            file.type !==
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ) {
            return antdMessageError("Please upload excel file");
          }

          const formData = new FormData();
          formData.append("file", file);

          const { data: total } = await Axios.post(
            "/api/v1/product_imports/count_total_products",
            formData
          );

          setDocuments((prev) => [
            ...prev,
            {
              total,
              file,
            },
          ]);
        }}
      />
      <Label required={true}>Products</Label>
      <div
        style={{
          width: "100%",
          border: `1px dashed ${false ? "red" : "#d9d9d9"}`,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "25px 15px",
          borderRadius: "2px",
          background: "#fafafa",
          cursor: "pointer",
          WebkitTransition: "border-color 0.3s",
          transition: "border-color 0.3s",
        }}
        onClick={() => fileRef.current.click()}
      >
        <div className="ant-upload-text">
          <FiUpload className="mr-2" /> Upload the file here.
        </div>
      </div>

      <button
        className="text-primary initial-button mt-1 mb-2"
        onClick={() => null}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
        >
          <path
            d="M2.33398 4.37508V1.75008C2.33398 1.59537 2.39544 1.447 2.50484 1.3376C2.61424 1.22821 2.76261 1.16675 2.91732 1.16675H11.084C11.2387 1.16675 11.3871 1.22821 11.4965 1.3376C11.6059 1.447 11.6673 1.59537 11.6673 1.75008V12.2501C11.6673 12.4048 11.6059 12.5532 11.4965 12.6626C11.3871 12.772 11.2387 12.8334 11.084 12.8334H2.91732C2.76261 12.8334 2.61424 12.772 2.50484 12.6626C2.39544 12.5532 2.33398 12.4048 2.33398 12.2501V9.62508"
            stroke="#03B0F7"
            strokeWidth="1.16667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.04199 4.37524H9.91699M8.16699 6.70858H9.91699M8.16699 9.04191H9.91699"
            stroke="#03B0F7"
            strokeWidth="1.16667"
            strokeLinecap="round"
          />
          <path
            d="M2.91699 6.12524L4.66699 7.87524M4.66699 6.12524L2.91699 7.87524M1.16699 4.37524H6.41699V9.62524H1.16699V4.37524Z"
            stroke="#03B0F7"
            strokeWidth="1.16667"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <a href="/files/product_mass_import_sample_2026-01-23.xlsx" download>
          <span className="text-decoration-underline pl-1">
            Download XSLX sample
          </span>
        </a>
      </button>

      {documents.map(({ total, file }) => (
        <div
          key={file.lastModified}
          className="px-3 py-2 mb-4"
          style={{
            border: "1px solid #D9D9D9",
            borderRadius: 4,
          }}
        >
          <div>
            <span className="font-medium">{total}</span> products will be
            imported
          </div>
          <div className="d-flex align-items-center justify-content-between">
            <div>
              <button
                className="text-primary initial-button mt-1 mb-2"
                onClick={() => {
                  const blob = new Blob([file], { type: file.type });
                  const downloadLink = document.createElement("a");
                  downloadLink.href = URL.createObjectURL(blob);
                  downloadLink.download = file.name;

                  document.body.appendChild(downloadLink);
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                >
                  <path
                    d="M11.1761 2.57168C9.70421 1.0998 7.30734 1.0998 5.83703 2.57168L1.7589 6.64668C1.73234 6.67324 1.71828 6.70918 1.71828 6.74668C1.71828 6.78418 1.73234 6.82012 1.7589 6.84668L2.33546 7.42324C2.36182 7.44948 2.39749 7.46421 2.43468 7.46421C2.47187 7.46421 2.50755 7.44948 2.5339 7.42324L6.61203 3.34824C7.11828 2.84199 7.79171 2.56387 8.50734 2.56387C9.22296 2.56387 9.8964 2.84199 10.4011 3.34824C10.9073 3.85449 11.1855 4.52793 11.1855 5.24199C11.1855 5.95762 10.9073 6.62949 10.4011 7.13574L6.24484 11.2904L5.5714 11.9639C4.94171 12.5936 3.91828 12.5936 3.28859 11.9639C2.9839 11.6592 2.81671 11.2545 2.81671 10.8232C2.81671 10.392 2.9839 9.98731 3.28859 9.68262L7.41203 5.56074C7.51671 5.45762 7.65421 5.39981 7.80109 5.39981H7.80265C7.94953 5.39981 8.08546 5.45762 8.18859 5.56074C8.29328 5.66543 8.34953 5.80293 8.34953 5.9498C8.34953 6.09512 8.29171 6.23262 8.18859 6.33574L4.81828 9.70293C4.79171 9.72949 4.77765 9.76543 4.77765 9.80293C4.77765 9.84043 4.79171 9.87637 4.81828 9.90293L5.39484 10.4795C5.42119 10.5057 5.45687 10.5205 5.49406 10.5205C5.53125 10.5205 5.56692 10.5057 5.59328 10.4795L8.96203 7.11074C9.27296 6.79981 9.44328 6.38731 9.44328 5.94824C9.44328 5.50918 9.2714 5.09512 8.96203 4.78574C8.31984 4.14355 7.27609 4.14512 6.6339 4.78574L6.2339 5.1873L2.51203 8.90762C2.25942 9.15874 2.05918 9.45752 1.92293 9.78663C1.78667 10.1157 1.71711 10.4686 1.71828 10.8248C1.71828 11.5482 2.00109 12.2279 2.51203 12.7389C3.04171 13.267 3.73546 13.5311 4.42921 13.5311C5.12296 13.5311 5.81671 13.267 6.34484 12.7389L11.1761 7.91074C11.887 7.19824 12.2808 6.2498 12.2808 5.24199C12.2823 4.23262 11.8886 3.28418 11.1761 2.57168Z"
                    fill="black"
                    fillOpacity="0.45"
                  />
                </svg>
                <span className="text-decoration-underline pl-1">
                  {file.name}
                </span>
              </button>
            </div>
            <ButtonDelete
              onDelete={() =>
                setDocuments((prev) =>
                  prev.filter((s) => s.file.lastModified !== file.lastModified)
                )
              }
            />
          </div>
        </div>
      ))}
      <div
        style={{
          height: 40,
        }}
      >
        <ButtonSecondary
          loading={mutationFile.isLoading}
          disabled={documents.length == 0}
          onClick={async () => {
            const formData = new FormData();
            documents.forEach(({ file }, idx) => {
              formData.append(`files[]`, file);
            });

            await mutationFile.mutate(formData);
          }}
        >
          Import
        </ButtonSecondary>
      </div>
    </ModalSimple>
  );
};
